import React from 'react';
import AddAttendeeContainer from '../../../Containers/UserContainer/AddAttendees';

const AddAttendeeScreen = () => {
  return <AddAttendeeContainer />;
};

export default AddAttendeeScreen;
